import { create } from 'zustand'

const TOKEN_KEY = 'ai-hub:member-token'

interface MemberSessionState {
  token: string | undefined
  authenticated: boolean
  passwordChangeRequired: boolean
  loginNotificationPromptVersion: number
  setToken: (token: string) => void
  setPasswordChangeRequired: (required: boolean) => void
  clear: () => void
}

export const useMemberSession = create<MemberSessionState>((set) => ({
  token: localStorage.getItem(TOKEN_KEY) ?? undefined,
  authenticated: Boolean(localStorage.getItem(TOKEN_KEY)),
  passwordChangeRequired: false,
  loginNotificationPromptVersion: 0,
  setToken: (token) => {
    localStorage.setItem(TOKEN_KEY, token)
    set((state) => ({ token, authenticated: true, passwordChangeRequired: false, loginNotificationPromptVersion: state.loginNotificationPromptVersion + 1 }))
  },
  setPasswordChangeRequired: (required) => {
    set({ passwordChangeRequired: required })
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY)
    set({ token: undefined, authenticated: false, passwordChangeRequired: false })
  },
}))

export function getMemberToken() {
  return useMemberSession.getState().token
}

export function clearMemberSession() {
  useMemberSession.getState().clear()
}

export function setMemberPasswordChangeRequired(required: boolean) {
  useMemberSession.getState().setPasswordChangeRequired(required)
}
